import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-organizationalchart',
  imports: [RouterLink],
  templateUrl: './organizationalchart.html',
})
export class Organizationalchart {

}
